import { render, staticRenderFns } from "./admin-module-role-setting.vue?vue&type=template&id=64c8b55f&scoped=true&"
import script from "./admin-module-role-setting.vue?vue&type=script&lang=js&"
export * from "./admin-module-role-setting.vue?vue&type=script&lang=js&"
import style0 from "./admin-module-role-setting.vue?vue&type=style&index=0&id=64c8b55f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8b55f",
  null
  
)

export default component.exports